import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { TmsDataBlock } from '../blocks/TmsDataBlock'
import { LayerWrapper } from './LayerWrapper'
import { createRestLaneResolver, toMs } from './lanes'
import { LayerProps } from './types'

const TmsDataLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { tmsData } = useTimelineData()


  const laneResolver = React.useMemo(() => {
    const spans = (tmsData || [])
      .map((t: any) => ({
        s: toMs(t.displayedLoadingDate),
        e: toMs(t.displayedUnloadingDate),
      }))
      .filter((sp) => !isNaN(sp.s) && !isNaN(sp.e) && sp.e > sp.s)
      .map((sp) => ({ ...sp, len: sp.e - sp.s }))
    return createRestLaneResolver(spans)
  }, [tmsData])

  return (
    <LayerWrapper zIndex={zIndex}>
      {tmsData.map((item, index) => (
        <TmsDataBlock
          key={index}
          currentTmsData={item}
          index={index}
          lane={laneResolver.restLaneFor(
            item.displayedLoadingDate,
            item.displayedUnloadingDate,
          )}
        />
      ))}
    </LayerWrapper>
  )
}

export default TmsDataLayer
